import React, { memo, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Icon, Stack, useMediaQuery } from "investira.react.components";
import { PageTemplate } from "../../components/templates";
import { OUTPUT } from "../../enums";
import EnquadramentoSettings from "./_settings/EnquadramentoSettings";
import AddEnquadramentoPadrao from "./_components/AddEnquadramentoPadrao";
import withEnquadramentos from "../../hoc/withEnquadramentos";

const ReportSettings = memo((props) => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const isUpSm = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  return (
    <PageTemplate
      title="Configurações"
      subtitle={OUTPUT[params.output].descricao}
      scrollable={true}
      maxWidth="lg"
      headerRenderActions={
        <Stack direction="row" spacing={2}>
          <AddEnquadramentoPadrao callback={props.readEntidadeEnquadramentos} />
          <Button
            variant="contained"
            color="primary"
            startIcon={<Icon iconName="insert" size={16} />}
            size="small"
            sx={{ px: 2 }}
            onClick={() => navigate(`${location.pathname}/add`)}
          >
            {isUpSm ? `Novo ${OUTPUT[params.output].descricao}` : "Novo"}
          </Button>
        </Stack>
      }
    >
      <EnquadramentoSettings {...props} />
    </PageTemplate>
  );
});

export default withEnquadramentos(ReportSettings);
